export default __webpack_public_path__ + "static/media/email.6d7fac2a.png";